import { TechnicalConfigGroupTable } from "features/shared/components/technical-config-tab/TechnicalConfigGroupTable";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import type { ConstructionGroup } from "../model/types";
import type { LayeredConstructionVariant } from "../model/variants";

import { getGroupTableHeaders } from "../lib/groupTableHeaders";

type GroupTableProps = {
  groups: ConstructionGroup[];
  isLoading: boolean;
  onConfigure: (group: ConstructionGroup) => void;
  onDelete: (group: ConstructionGroup) => void;
  variant: LayeredConstructionVariant;
};

export const GroupTable = ({ groups, isLoading, onConfigure, onDelete, variant }: GroupTableProps) => {
  const { t } = useTranslation();
  const headers = useMemo(() => getGroupTableHeaders({ onConfigure, t, variant }), [onConfigure, t, variant]);

  return (
    <TechnicalConfigGroupTable
      columnsMinWidth="10rem"
      groups={groups}
      headers={headers}
      idColumnName="userDefinedType"
      isLoading={isLoading}
      onDelete={onDelete}
      rowRemoveable={(row) => row.hasTechnology}
    />
  );
};
